const DAY_MS = 24 * 60 * 60 * 1000;

export const EXPIRY_NEVER = 'never';
export const EXPIRY_CUSTOM = 'custom';

export const EXPIRY_PRESETS = [
  { value: EXPIRY_NEVER, label: 'Never expires', days: null },
  { value: '1', label: 'In 1 day', days: 1 },
  { value: '7', label: 'In 7 days', days: 7 },
  { value: '30', label: 'In 30 days', days: 30 },
  { value: '90', label: 'In 90 days', days: 90 },
  { value: EXPIRY_CUSTOM, label: 'Custom date…', days: null },
];

export function buildShareLink(token) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/share/${token}`;
}

export async function copyToClipboard(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.log('clipboard.writeText failed:', err);
    }
  }
  if (typeof document === 'undefined') return false;
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (err) {
    console.log('execCommand copy failed:', err);
    return false;
  }
}

export function presetToExpiresAt(presetValue, customValue, now = Date.now()) {
  if (presetValue === EXPIRY_NEVER) return null;
  if (presetValue === EXPIRY_CUSTOM) {
    if (!customValue) return null;
    const date = new Date(customValue);
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString();
  }
  const preset = EXPIRY_PRESETS.find((p) => p.value === presetValue);
  if (!preset || !preset.days) return null;
  return new Date(now + preset.days * DAY_MS).toISOString();
}

export function toDateTimeLocalValue(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function isShareExpired(share, now = Date.now()) {
  if (!share?.expiresAt) return false;
  const expires = new Date(share.expiresAt).getTime();
  return Number.isFinite(expires) && expires <= now;
}

export function describeShareExpiry(expiresAt, now = Date.now()) {
  if (!expiresAt) {
    return { status: 'never', label: 'Never expires' };
  }
  const expires = new Date(expiresAt);
  const ms = expires.getTime() - now;
  if (!Number.isFinite(ms)) {
    return { status: 'never', label: 'Never expires' };
  }
  const dateLabel = expires.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
  if (ms <= 0) {
    return { status: 'expired', label: `Expired ${dateLabel}` };
  }
  const hours = Math.round(ms / (60 * 60 * 1000));
  if (hours < 1) {
    return { status: 'expiring', label: 'Expires in less than an hour' };
  }
  if (hours < 48) {
    return { status: 'expiring', label: `Expires in ${hours} hour${hours === 1 ? '' : 's'}` };
  }
  const days = Math.round(ms / DAY_MS);
  return { status: 'active', label: `Expires in ${days} day${days === 1 ? '' : 's'} (${dateLabel})` };
}

export function formatViewCount(count) {
  const n = Number(count) || 0;
  return `${n.toLocaleString()} ${n === 1 ? 'view' : 'views'}`;
}
